import auto from '../assets/images/auto.jpg';
import bureau from '../assets/images/bureau.jpg';
import maison from '../assets/images/maison.jpg';

export const services = [
  {
    image: auto,
    name: "Nettoyage voiture",
    description:"Un intérieur propre et confortable pour voyager sereinement, associé à un nettoyage extérieur intensif qui fait briller votre voiture de mille feux. La propreté qui se voit et se ressent dès le premier regard.",
  },
  {
    image: bureau,
    name: "Nettoyage de bureau",
    description:"Un environnement de travail propre et sain pour favoriser la productivité. Notre service de nettoyage de bureau s'assure que chaque coin est impeccablement entretenu, créant ainsi un espace agréable pour vos employés et vos clients.",
  },
  {
    image: maison,
    name: "Nettoyage de maison",
    description:"Un service de nettoyage complet pour votre maison, garantissant un espace de vie propre et accueillant. Nous nous occupons de chaque détail, de la poussière aux surfaces, pour que vous puissiez profiter d'un intérieur impeccable.",
  }
]

export default services;